// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import StringListResultModel from '../../model/string-list-result-model';
import StringListResultDTO from '../dto/string-list-result-dto';
import dtoSchema from '../schemas/string-list-result-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class StringListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<StringListResultDTO>) {
    super();
    if (data) {
      this.items = data.items ?? undefined;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: string[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<StringListResultDTO>): StringListResultModel;
  static toModel(dto: DeepPartial<StringListResultDTO> | undefined | null): StringListResultModel | undefined;
  static toModel(dto: DeepPartial<StringListResultDTO> | undefined | null): StringListResultModel | undefined {
    return dto ? new StringListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<StringListResultModel> | StringListResultModel): StringListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as StringListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for StringListResultModel, can not map to StringListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
